module.exports = __webpack_public_path__ + "assets/img/bg.d831afa3.png";